
  export const isOfficeFile = (filePath: string): boolean => {
    const extension = filePath.split('.').pop()?.toLowerCase();
    return extension === 'xls' || extension === 'xlsx' || extension === 'doc' || extension === 'docx' || extension === 'ppt' || extension === 'pptx';
  };
